// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Index from './index/index'

const bikeRoutes = [
  route('index', '/index', Index, meta('Lista de Arquivos', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/files', bikeRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/files/routes.js